import React from 'react';
import './Pages.css';
import Masonry, { ResponsiveMasonry } from 'react-responsive-masonry';

// Original images (non-ORE)
import img1 from '../media/1st overhaul.jpg';
import img2 from '../media/2.jpg';
import img3 from '../media/2010 panel.jpg.jpg';
import img4 from '../media/28665 original panel.jpg';
import img5 from '../media/3.jpg';
import img6 from '../media/3.mechanic.jpg';
import img7 from '../media/7. Rob finishes engine.jpg';
import img8 from '../media/Ceramic 1.jpg';
import img9 from '../media/IMG_5026.JPG';
import img10 from '../media/P0000549.JPG';
import img11 from '../media/panel2002.jpg';

// New images
import img12 from '../media/1519230352ff70c1f90858672a065d69.jpg';
import img13 from '../media/2580268729170934d78ca6952116d377.jpg';
import img14 from '../media/32a8861388847f3c21d1486feac32ec0.jpg';
import img15 from '../media/6db87b579c24950aa2df0c2c5d18037e.jpg';
import img16 from '../media/708d7f5a1983d5c04fa8d7c3278155a3.jpg';
import img17 from '../media/7373ce35462c1ce27af0dd39896e2ef0.jpg';
import img18 from '../media/7e9d7710901a196e0e3a2c0c51c36982.jpg';
import img19 from '../media/b72ba0bb29e0be5c055425a252a259a2.jpg';
import img20 from '../media/bdd27e70038d999580eea49b63c366f9.jpg';
import img21 from '../media/bf4230550f867b4f8330f56c5632def8.jpg';
import img22 from '../media/f4d6161b59870b86af56df4376050135.jpg';
import img23 from '../media/f9ab499921043251b42e8d7c2fd41246.jpg';

const images = [
  img1, img2, img3, img4, img5, img6, img7, img8, img9, img10, img11,
  img12, img13, img14, img15, img16, img17, img18, img19, img20, img21, img22, img23
];

const Gallery = () => {
  return (
    <div className="page">
      <h1>Photo Gallery</h1>
      <p>Explore our collection of travel memories and inspiring destinations.</p>

      <ResponsiveMasonry
        columnsCountBreakPoints={{ 350: 1, 750: 2, 900: 3 }}
      >
        <Masonry gutter="10px">
          {images.map((src, idx) => (
            <img
              key={idx}
              src={src}
              alt={`Travel memory ${idx + 1}`}
              style={{ width: "100%", display: "block", borderRadius: "8px" }}
            />
          ))}
        </Masonry>
      </ResponsiveMasonry>
    </div>
  );
};

export default Gallery;
